import vehicle from './vehicle';
import items from './items';
import widgetInfo from './widgetInfo';

const root = {
	vehicle,
	items,
	widgetInfo
};

export default root;
